import { useMemo } from 'react'
import { gql, useQuery } from '@apollo/client'
import { IPTVChannel, IPTVChannelResponse, UseIPTVResult } from './types'
import { useSites } from 'store'

export const OPERATION_FIND_CHANNELS = gql`
  query GetChannels($siteId: ID!) {
    findIPTVChannels(siteId: $siteId) {
      logo
      name
      canal
      isWorking
      ipAddress
      port
      type
      quality
      bitrate
      wisiInput
      wisiModule
    }
  }
`

export const OPERATION_EXPORT_CHANNELS = gql`
  query ExportIPTVChannels($siteId: ID!, $format: String!, $language: String) {
    exportIPTVChannels(siteId: $siteId, format: $format, language: $language)
  }
`

export const useIPTV = (searchTerm: string = ''): UseIPTVResult => {
  const [{ selected }] = useSites()
  const activeSiteId = selected.length ? selected[selected.length - 1].sf_id : null

  const { data, loading, error } = useQuery(OPERATION_FIND_CHANNELS, {
    variables: { siteId: activeSiteId },
    skip: !activeSiteId
  })

  const channels = useMemo(() => {
    if (!activeSiteId || !data) return []

    const mappedChannels: IPTVChannel[] = data.findIPTVChannels.map((channel: IPTVChannelResponse) => ({
      id: channel.canal,
      name: channel.name,
      logo: channel.logo,
      mode: 'udp',
      position: parseInt(channel.canal),
      service_id: parseInt(channel.canal),
      ip_address: channel.ipAddress,
      port: channel.port,
      type: channel.type,
      module: channel.wisiModule,
      wisi_input_name: channel.wisiInput,
      wisi_output_name: channel.name,
      quality: channel.quality,
      bitrate: channel.bitrate,
      configured_on_wisi: true,
      errors: [],
      has_errors: !channel.isWorking
    }))

    if (!searchTerm) return mappedChannels

    const searchLower = searchTerm.toLowerCase()
    return mappedChannels.filter(channel => 
      channel.name.toLowerCase().includes(searchLower) ||
      channel.ip_address.includes(searchLower) ||
      channel.type.toLowerCase().includes(searchLower)
    )
  }, [data, searchTerm, activeSiteId])

  return {
    channels: channels || [],
    error,
    loading,
    activeSiteId: activeSiteId || null
  }
}

export default useIPTV

